var r=class extends Error{name="MUDError"};export{r as a};
//# sourceMappingURL=chunk-UPQEB2HW.js.map